/**
 * Domain Adapter — Subsea / Offshore (OSDU R3)
 *
 * Phase-2 deliverable. Covers subsea and offshore assets per OSDU R3 and
 * ISO 19901. Not-yet-implemented; returns an explicit typed error.
 */

import type { SceneItem } from "@/sdk-stub/gtwin-sdk/types";
import type { DomainAdapter, DomainAdapterContext, AdapterResult } from "../DomainAdapter";

export const OsduSubseaAdapter: DomainAdapter = {
  domain: "subsea",
  version: "1.0.0",
  standard: "OSDU-R3",

  /**
   * Detects OSDU subsea assets.
   * Matches `layerKind === "osdu"` or explicit domain extension.
   */
  detect(item: SceneItem): boolean {
    type Extended = SceneItem & { extensions?: { geosoft?: { domain?: string } } };
    const ext = (item as Extended).extensions?.geosoft;
    if (ext?.domain === "subsea") return true;
    return item.layerKind === "osdu";
  },

  async buildManifest(
    _item: SceneItem,
    _asset: { layerId: string; assetNodeId: string; gtwinId: string },
    _context: DomainAdapterContext,
  ): Promise<AdapterResult> {
    return {
      ok: false,
      error: {
        kind: "not-implemented",
        domain: "subsea",
        message:
          "Phase 2 deliverable; fall back to synthetic Tier-1 view.",
      },
    };
  },
};
